import { render, staticRenderFns } from "./contratosParaRenovarSidebar.vue?vue&type=template&id=dcabbe32"
import script from "./contratosParaRenovarSidebar.vue?vue&type=script&lang=js"
export * from "./contratosParaRenovarSidebar.vue?vue&type=script&lang=js"
import style0 from "./contratosParaRenovarSidebar.vue?vue&type=style&index=0&id=dcabbe32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports